const RENTALS_CONTRACTS = {
  //_getContract
  RENTALS_CONTRACT: 'RENTALS_CONTRACT',
  //_getPropertyContracts
  RENTALS_PROPERTY_CONTRACTS: 'RENTALS_PROPERTY_CONTRACTS',
  //_getPropertyActiveContracts
  RENTALS_PROPERTY_ACTIVE_CONTRACT: 'RENTALS_PROPERTY_ACTIVE_CONTRACT',
  //_getUnitsContractsList
  RENTALS_UNITS_CONTRACTS: 'RENTALS_UNITS_CONTRACTS',
  //_getContractsPaymentModel
  RENTALS_CONTRACTS_PAYMENT_MODEL: 'RENTALS_CONTRACTS_PAYMENT_MODEL',
  //getContracts
  RENTALS_CONTRACTS: 'RENTALS_CONTRACTS',
  //getContractCode
  RENTALS_CONTRACT_CODE: 'RENTALS_CONTRACT_CODE',
  //addNewContract
  RENTALS_ADD_NEW_CONTRACT: 'RENTALS_ADD_NEW_CONTRACT',
  //updateContract
  RENTALS_UPDATE_CONTRACT: 'RENTALS_UPDATE_CONTRACT',
  //_getContractsPaymentModel
  RENTALS_CONTRACTS_RENTERS: 'RENTALS_CONTRACTS_RENTERS',
  //_getCounties
  RENTALS_COUNTIES: 'RENTALS_COUNTIES',
  //_getOptionPaymentModel
  RENTALS_OPTION_PAYMENT_MODEL_RENTERS: 'RENTALS_OPTION_PAYMENT_MODEL_RENTERS',
  //_getDocumentVersion
  RENTALS_CONTRACTS_DOCUMENT_VERSION: 'RENTALS_CONTRACTS_DOCUMENT_VERSION',
  //_getDocumentVersionOfGeneralConditions
  RENTALS_CONTRACTS_DOCUMENT_VERSION_OF_GENERAL_CONDITIONS:
    'RENTALS_CONTRACTS_DOCUMENT_VERSION_OF_GENERAL_CONDITIONS',
  //_getContractDetails
  RENTALS_CONTRACT_DETAILS: 'RENTALS_CONTRACT_DETAILS',
  //_getContractDocuments
  RENTALS_CONTRACTS_CONTRACT_DOCUMENTS: 'RENTALS_CONTRACTS_CONTRACT_DOCUMENTS',
  //get_getContractDocumentPdf
  RENTALS_CONTRACTS_CONTRACT_DOCUMENT_PDF: 'RENTALS_CONTRACTS_CONTRACT_DOCUMENT_PDF',
  //_getContractAllotmans
  RENTALS_CONTRACT_ALLOTMANS: 'RENTALS_CONTRACT_ALLOTMANS',
  //_ContractDetailsActionButtons
  RENTALS_CONTRACT_CONTRACT_DETAILS_ACTION_BUTTONS:
    'RENTALS_CONTRACT_CONTRACT_DETAILS_ACTION_BUTTONS',
  //_getContractTemplates
  RENTALS_CONTRACT_TEMPLATES: 'RENTALS_CONTRACT_TEMPLATES',
};

export default RENTALS_CONTRACTS;
